import { render, staticRenderFns } from "./admin_table_card.vue?vue&type=template&id=0911720c"
import script from "./admin_table_card.vue?vue&type=script&lang=js"
export * from "./admin_table_card.vue?vue&type=script&lang=js"
import style0 from "./admin_table_card.vue?vue&type=style&index=0&id=0911720c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports